export default __webpack_public_path__ + "images/a46d7c9a78cc3b9f4846e4727d4fb21c.png";